import React, { FC, ReactElement } from 'react';
import Link from 'next/link';

type MembersCard = {
  company: string;
  name: string;
  description: string;
  image: string;
  alt: string;
};

const MembersCard: FC<MembersCard> = ({ company, name, description, image, alt = '' }: MembersCard): ReactElement => {
  return (
    <div className="india__members-card">
      <div className="india__members-card-image-box">
        <img
          className="india__members-card-image"
          src={`/images/pages/Resources/FreightForwarderInCountry/India/${image}`}
          alt={alt}
        />
      </div>
      <div className="india__members-card-content-box">
        <p className="india__members-card-company">
          <span className="india__members-card-company-text">{company}</span>
        </p>
        <p className="india__members-card-name">{name}</p>
        <p className="india__members-card-description">{description}</p>
        <div className="india__members-card-links-box">
          <span>Show more information</span>
        </div>
      </div>
    </div>
  );
};

export default MembersCard;
